/* eslint-disable */ import { childEntityRecipesComponent, memoEval, sceneEntityAddFabComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const wallCabinetComponents = [
    attachComponent.withComponent(sceneEntityAddFabComponent, 'addBlockFab', true).withEntity('WallCabinet').withGradualFilter({
        active: (self)=>self.$isLastSegment
    }).attach(memoEval((self)=>[
            self.$fabOffsetY
        ], ($fabOffsetY)=>({
            offsetX: 30,
            offsetY: $fabOffsetY,
            offsetZ: 12,
            instanceNames: [
                'tallCabinet',
                'wallCabinet',
                'emptySpace'
            ],
            skipMenuWhenOnlyOne: false,
            showWhen: [
                'selected',
                'unselected'
            ],
            azimuthAngleLimits: {
                min: -0.1,
                max: 0.3
            }
        }))),
    attachComponent.withComponent(sceneEntityAddFabComponent, 'addBlockFabLeft', true).withEntity('WallCabinet').withGradualFilter({
        active: (self)=>self.$isFirstSegment
    }).attach(memoEval((self)=>[
            self.$fabOffsetY
        ], ($fabOffsetY)=>({
            offsetX: -7,
            offsetY: $fabOffsetY,
            offsetZ: 12,
            instanceNames: [
                'tallCabinetLeft',
                'wallCabinetLeft',
                'emptySpaceLeft'
            ],
            skipMenuWhenOnlyOne: false,
            showWhen: [
                'selected',
                'unselected'
            ],
            azimuthAngleLimits: {
                min: -0.1,
                max: 0.3
            }
        }))),
    attachComponent.withComponent(sceneEntityAddFabComponent, 'addBaseBelowFab', true).withEntity('WallCabinet').withGradualFilter({
        active: (self)=>self.$noBaseCabinetBelow
    }).attach(memoEval(()=>[], ()=>({
            offsetX: 12,
            offsetY: 20,
            offsetZ: 12,
            instanceNames: [
                'baseCabinetBelow',
                'noCabinetBelow'
            ],
            skipMenuWhenOnlyOne: false,
            showWhen: [
                'selected',
                'unselected'
            ],
            azimuthAngleLimits: {
                min: -0.1,
                max: 0.3
            }
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('WallCabinet').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/higgins.glb',
            objectName: 'W2430',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'baseCabinetBelow', true).withEntity('WallCabinet').attach(memoEval((self)=>[
            self.$baseCabinetBelowRecipes
        ], ($baseCabinetBelowRecipes)=>({
            groupLabel: 'Base Cabinet',
            recipes: $baseCabinetBelowRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'noCabinetBelow', true).withEntity('WallCabinet').attach(memoEval((self)=>[
            self.$noCabinetBelowRecipes
        ], ($noCabinetBelowRecipes)=>({
            groupLabel: 'No Cabinet',
            recipes: $noCabinetBelowRecipes
        })))
];

//# sourceMappingURL=wall-cabinet.js.map